import { useRecoilValue, useSetRecoilState } from 'recoil';
import { useTranslation } from '@zurich/common/hooks';
import { InfoSummary } from '~/components/Steps/InfoSummary';
import type { SummaryDataType } from '~/lib/types';
import {
  activeStepSelector,
  confirmationOfCorrectAutoDataSelector,
  confirmationOfCorrectAutoDataValidationSelector,
  licensePlateFieldSelector,
} from '~/state';

export function AutoInfoSummary() {
  const { t } = useTranslation();
  const licensePlate = useRecoilValue(licensePlateFieldSelector);

  const setActiveStep = useSetRecoilState(activeStepSelector);

  const summaryData: SummaryDataType[] = [
    {
      title: t('vsga:summary.importantInfoPhotoQuality'),
      info: t('vsga:summary.confirmed'),
      onClick: () => setActiveStep('preCheck'),
    },
    {
      title: t('vsga:summary.licensePlate'),
      info: licensePlate ?? '',
      onClick: () => setActiveStep('licensePlate'),
    },
    {
      title: t('vsga:summary.kilometers'),
      info: t('vsga:summary.xPhotos', { count: 1, plural: '' }),
      onClick: () => setActiveStep('kilometers'),
    },
    {
      title: t('vsga:summary.serialNumber'),
      info: t('vsga:summary.xPhotos', { count: 1, plural: '' }),
      onClick: () => setActiveStep('serialnumber'),
    },
  ];

  return (
    <InfoSummary
      summaryData={summaryData}
      atom={confirmationOfCorrectAutoDataSelector}
      validationSelector={confirmationOfCorrectAutoDataValidationSelector}
      flexDirection="column-reverse"
    />
  );
}
